/* eslint-disable import/no-cycle */
// Utils
import { commitOrReturn } from './commitOrReturn';
/**
 * Commits all objects contained in an array
 * @see commitOrReturn
 *
 * @param {any[]} array
 *
 * @return any[]
 */
export var commitArray = function (array) {
    // then map through this and return
    var hasChanges = false;
    var newArrayValue;
    var newArray = array.map(function (arrayValue) {
        newArrayValue = commitOrReturn(arrayValue);
        if (newArrayValue !== arrayValue) {
            hasChanges = true;
        }
        return newArrayValue;
    });
    return hasChanges
        ? newArray
        : array;
};
//# sourceMappingURL=commitArray.js.map